import React from "react";
import { Link } from "react-router-dom";
import logoImg from "images/rentrips-biru.png";
import logoLightImg from "images/rentrips-dark.png";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
  handleClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
  className = "",
  handleClick = () => {},
}) => {
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-primary-6000 ${className} focus:ring-0 focus:border-0`}
      onClick={handleClick}
    >
      {/* THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {img ? (
        <img
          className={`block max-h-12 ${imgLight ? "dark:hidden" : ""}`}
          src={img}
          alt="Logo"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className="hidden max-h-12 dark:block"
          src={imgLight}
          alt="Logo-Light"
        />
      )}
    </Link>
  );
};

export default Logo;
